import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";

@Injectable()
export class SubstrateService {
  constructor(private apiHttp: ApiHttpService) {}

  public getAll = (): Observable<Substrate[]> => {
    return this.apiHttp.get<Substrate[]>("substrates");
  };

  public get = (id: number): Observable<Substrate> => {
    return this.apiHttp.get<Substrate>(`substrates/${id}`);
  };
}

export interface Substrate {
  id: number;
  name: string;
  isActive: boolean;
  requiresFollowup: boolean;
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/services/substrate.service.ts